/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_9_HInputs */

const en_terms_9_h = /** @type {(inputs: Terms_9_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Governing law and changes`)
};

const id_terms_9_h = /** @type {(inputs: Terms_9_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hukum yang berlaku dan perubahan`)
};

/**
* | output |
* | --- |
* | "Governing law and changes" |
*
* @param {Terms_9_HInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const terms_9_h = /** @type {((inputs?: Terms_9_HInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_9_HInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_terms_9_h(inputs)
	return en_terms_9_h(inputs)
});